import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import apis from '../../../../apis'
import { getJwtToken } from '../../../../auth'
import QueryApi from '../../../../react-query/queryApiClass'
import { IContentProgramsResponse } from './types'

interface IContentProgramQueryApiPathParams {
  type: string
}

const contentProgramsInfo = new QueryApi<IContentProgramQueryApiPathParams>({
  api: apis.study.contentPrograms,
})

export const useAppliedContentPrograms = (type: string, options = {}) => {
  const token = getJwtToken()

  const pathParams = { type }

  return useQuery<IContentProgramsResponse, AxiosError>({
    queryKey: contentProgramsInfo.getQueryKey({ pathParams }),
    queryFn: contentProgramsInfo.getQueryFn({ pathParams }),
    // onError: (e) => handleAxiosError(e),
    enabled: !!token && !!type,
    ...options,
  })
}
